var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "mt-1", attrs: { cols: "12" } },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.modal-main",
                      modifiers: { "modal-main": true },
                    },
                  ],
                  staticClass: "my-1",
                  attrs: { variant: "primary" },
                },
                [_vm._v(" Add Supplier ")]
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-main",
                "cancel-variant": "outline-secondary",
                centered: "",
                title: "Add Supplier",
                "hide-footer": "",
              },
            },
            [
              _c(
                "validation-observer",
                {
                  ref: "AddSupplierForm",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.validationForm($event)
                    },
                  },
                },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Supplier Name:*"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              name: "name",
                              vid: "name",
                              rules: "supplier_name",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "name",
                                        type: "text",
                                        placeholder: "Supplier Name",
                                      },
                                      model: {
                                        value: _vm.name,
                                        callback: function ($$v) {
                                          _vm.name = $$v
                                        },
                                        expression: "name",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Email:*"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              rules: { required: true, email_message: true },
                              name: "email",
                              vid: "email",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "email",
                                        type: "email",
                                        placeholder: "Email Address",
                                      },
                                      model: {
                                        value: _vm.email,
                                        callback: function ($$v) {
                                          _vm.email = $$v
                                        },
                                        expression: "email",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Address:"),
                          ]),
                          _c("validation-provider", {
                            attrs: { name: "Address", vid: "Address" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "address",
                                        type: "text",
                                        placeholder: "Address",
                                      },
                                      model: {
                                        value: _vm.address,
                                        callback: function ($$v) {
                                          _vm.address = $$v
                                        },
                                        expression: "address",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Phone Number:"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              rules: { phone: true },
                              name: "Phone",
                              vid: "Phone",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "phoneNumber",
                                        type: "text",
                                        placeholder: "Phone number",
                                      },
                                      on: {
                                        keypress: function ($event) {
                                          return _vm.allowOnlyNumbers($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.phoneNumber,
                                        callback: function ($$v) {
                                          _vm.phoneNumber = $$v
                                        },
                                        expression: "phoneNumber",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Goods Supplied:"),
                          ]),
                          _c("validation-provider", {
                            attrs: { name: "Goods", vid: "Goods" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "goodsSupplied",
                                        type: "text",
                                        placeholder: "Goods Supplied",
                                      },
                                      model: {
                                        value: _vm.goodsSupplied,
                                        callback: function ($$v) {
                                          _vm.goodsSupplied = $$v
                                        },
                                        expression: "goodsSupplied",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "email" } }, [
                            _vm._v("Contact Person:"),
                          ]),
                          _c("validation-provider", {
                            attrs: { name: "Contact", vid: "Contact" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "contactPerson",
                                        type: "text",
                                        placeholder: "Contact Person",
                                      },
                                      model: {
                                        value: _vm.contactPerson,
                                        callback: function ($$v) {
                                          _vm.contactPerson = $$v
                                        },
                                        expression: "contactPerson",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "brn" } }, [
                            _vm._v("BRN:"),
                          ]),
                          _c("validation-provider", {
                            attrs: { name: "BRN", vid: "BRN" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "brn",
                                        type: "text",
                                        placeholder:
                                          "Business Registration Number",
                                      },
                                      model: {
                                        value: _vm.brn,
                                        callback: function ($$v) {
                                          _vm.brn = $$v
                                        },
                                        expression: "brn",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "vatNumber" } }, [
                            _vm._v("VAT No:"),
                          ]),
                          _c("validation-provider", {
                            attrs: { name: "VAT No", vid: "VAT No" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "vatNumber",
                                        type: "text",
                                        placeholder: "VAT Number",
                                      },
                                      model: {
                                        value: _vm.vatNumber,
                                        callback: function ($$v) {
                                          _vm.vatNumber = $$v
                                        },
                                        expression: "vatNumber",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        [
                          _c("label", { attrs: { for: "reference" } }, [
                            _vm._v("Reference:"),
                          ]),
                          _c("validation-provider", {
                            attrs: {
                              name: "Supplier Reference",
                              vid: "Supplier Reference",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "reference",
                                        type: "text",
                                        placeholder: "Reference",
                                      },
                                      model: {
                                        value: _vm.reference,
                                        callback: function ($$v) {
                                          _vm.reference = $$v
                                        },
                                        expression: "reference",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("CustomFieldsDetails", {
                        attrs: {
                          AdditionalFields: _vm.additionalFields,
                          ModuleReference: "Supplier",
                        },
                        on: { onchange: _vm.additionalFieldChanges },
                      }),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.AddSupplier()
                              },
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticClass: "mx-2",
                                  attrs: { small: "" },
                                })
                              : _vm._e(),
                            _vm._v("Add "),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-edit",
                "cancel-variant": "outline-secondary",
                "ok-title": "Edit",
                "cancel-title": "Close",
                centered: "",
                title: "Edit Supplier",
                "hide-footer": "",
              },
              on: {
                hidden: function ($event) {
                  return _vm.reloadPage()
                },
                cancel: _vm.resetEditForm,
                close: _vm.resetEditForm,
              },
            },
            [
              _c("validation-observer", {
                ref: "EditSupplierForm",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var invalid = ref.invalid
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                              },
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "email" } }, [
                                  _vm._v("Supplier Name:*"),
                                ]),
                                _c("validation-provider", {
                                  attrs: {
                                    name: "name",
                                    vid: "name",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "name",
                                                type: "text",
                                                placeholder: "Supplier Name",
                                              },
                                              model: {
                                                value: _vm.supplierData.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "supplierData.name",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "email" } }, [
                                  _vm._v("Email:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "email",
                                    rule: "",
                                    name: "email",
                                    vid: "email",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "email",
                                                type: "email",
                                                placeholder: "Email Address",
                                                value: _vm.supplierData.email,
                                              },
                                              model: {
                                                value: _vm.supplierData.email,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "supplierData.email",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "email" } }, [
                                  _vm._v("Address:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: { name: "Address", vid: "Address" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "address",
                                                type: "text",
                                                placeholder: "John Doe",
                                              },
                                              model: {
                                                value: _vm.supplierData.address,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "address",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "supplierData.address",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "email" } }, [
                                  _vm._v("Phone Number:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: { name: "Phone", vid: "Phone" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "phoneNumber",
                                                type: "number",
                                                placeholder: "Phone number",
                                              },
                                              on: {
                                                keypress: function ($event) {
                                                  return _vm.allowOnlyNumbers(
                                                    $event
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.supplierData.phoneNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "phoneNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "supplierData.phoneNumber",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "email" } }, [
                                  _vm._v("Goods Supplied:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: { name: "Goods", vid: "Goods" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "goodsSupplied",
                                                type: "text",
                                                placeholder: "Goods Supplied",
                                              },
                                              model: {
                                                value:
                                                  _vm.supplierData
                                                    .goodsSupplied,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "goodsSupplied",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "supplierData.goodsSupplied",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "email" } }, [
                                  _vm._v("Contact Person:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: { name: "Contact", vid: "Contact" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "contactPerson",
                                                type: "text",
                                                placeholder: "Contact Person",
                                              },
                                              model: {
                                                value:
                                                  _vm.supplierData
                                                    .contactPerson,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "contactPerson",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "supplierData.contactPerson",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "brn" } }, [
                                  _vm._v("BRN:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: { name: "BRN", vid: "BRN" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "brn",
                                                type: "text",
                                                placeholder:
                                                  "Business Registration Number",
                                              },
                                              model: {
                                                value: _vm.supplierData.brn,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "brn",
                                                    $$v
                                                  )
                                                },
                                                expression: "supplierData.brn",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "vatNumber" } }, [
                                  _vm._v("VAT No:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: { name: "VAT No", vid: "VAT No" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "vatNumber",
                                                type: "text",
                                                placeholder: "VAT Number",
                                              },
                                              model: {
                                                value:
                                                  _vm.supplierData.vatNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "vatNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "supplierData.vatNumber",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              [
                                _c("label", { attrs: { for: "reference" } }, [
                                  _vm._v("Reference:"),
                                ]),
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Supplier Reference",
                                    vid: "Supplier Reference",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "reference",
                                                type: "text",
                                                placeholder: "Reference",
                                              },
                                              model: {
                                                value:
                                                  _vm.supplierData.reference,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.supplierData,
                                                    "reference",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "supplierData.reference",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("CustomFieldsDetails", {
                                  attrs: {
                                    AdditionalFields:
                                      _vm.supplierData.additionalFields,
                                    ModuleReference: "Supplier",
                                  },
                                  on: {
                                    onchange: _vm.additionalFieldChangesEdit,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    type: "button",
                                    block: "",
                                    disabled: invalid,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.EditSupplier()
                                    },
                                  },
                                },
                                [
                                  _vm.loading
                                    ? _c("b-spinner", {
                                        staticClass: "mx-2",
                                        attrs: { small: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v("Edit "),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-col", { attrs: { md: "4", sm: "8" } }),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.filteredSuppliers,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(name)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _c("span", [_vm._v("Name")]),
                        _c("b-form-input", {
                          attrs: { placeholder: "Filter by Name", size: "sm" },
                          on: { input: _vm.applyFilter },
                          model: {
                            value: _vm.filters.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "name", $$v)
                            },
                            expression: "filters.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(email)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _c("span", [_vm._v("Email")]),
                        _c("b-form-input", {
                          attrs: { placeholder: "Filter by Email", size: "sm" },
                          on: { input: _vm.applyFilter },
                          model: {
                            value: _vm.filters.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "email", $$v)
                            },
                            expression: "filters.email",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(address)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _c("span", [_vm._v("Address")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Address",
                            size: "sm",
                          },
                          on: { input: _vm.applyFilter },
                          model: {
                            value: _vm.filters.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "address", $$v)
                            },
                            expression: "filters.address",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(phoneNumber)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _c("span", [_vm._v("Phone Number")]),
                        _c("b-form-input", {
                          attrs: { placeholder: "Filter by Phone", size: "sm" },
                          on: { input: _vm.applyFilter },
                          model: {
                            value: _vm.filters.phoneNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "phoneNumber", $$v)
                            },
                            expression: "filters.phoneNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(goodsSupplied)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _c("span", [_vm._v("Goods Supplied")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Goods Supplied",
                            size: "sm",
                          },
                          on: { input: _vm.applyFilter },
                          model: {
                            value: _vm.filters.goodsSupplied,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "goodsSupplied", $$v)
                            },
                            expression: "filters.goodsSupplied",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(contactPerson)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _c("span", [_vm._v("Contact Person")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Contact Person",
                            size: "sm",
                          },
                          on: { input: _vm.applyFilter },
                          model: {
                            value: _vm.filters.contactPerson,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "contactPerson", $$v)
                            },
                            expression: "filters.contactPerson",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(avatar)",
                fn: function (data) {
                  return [_c("b-avatar", { attrs: { src: data.value } })]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    _c(
                      "b-badge",
                      { attrs: { variant: _vm.status[1][data.value] } },
                      [_vm._v(" " + _vm._s(_vm.status[0][data.value]) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "text-body align-middle mr-25",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-edit",
                                modifiers: { "modal-edit": true },
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.getSupplierData(data.item)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "Edit2Icon" },
                            }),
                            _c("span", [_vm._v("Edit")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.removeSupplier(data.item.id)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "TrashIcon" },
                            }),
                            _c("span", [_vm._v("Delete")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loading
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _c("b-form-group", [
            _vm._v(
              " Showing " +
                _vm._s(
                  _vm.totalRows > 0
                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                    : 0
                ) +
                " to " +
                _vm._s(
                  _vm.totalRows > 0
                    ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                    : 0
                ) +
                " of " +
                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                " entries "
            ),
          ]),
        ],
        1
      ),
      _c("b-col", { attrs: { cols: "12" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }